module.exports = {"menu":{"home":"Home","events":"Events","myYoop":"My Yoop","profile":"Profile","login":"Login","logout":"Log Out","signUp":"Sign Up","about":"About","careers":"Join Us","contact":"Contact Us","privacyPolicy":"Privacy Policy","termsOfUse":"Terms of Use","support":"Support"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src891534606/src/modules/web/src/js/i18n/english/menu.en.i18n.json
// module id = 1208
// module chunks = 0